import { Layout, Summary, Details, AddSummary } from '@/views/investment_plan';

export default {
    path: '/investment_plan',
    component: Layout,
    children: [
        { path: 'summary', component: Summary },
        { path: 'details', component: Details },
        { path: 'add-summary', component: AddSummary },
    ]
};
